import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@studiobuki/web-core/lib/button';
import { SectionFooterBannerComponent } from './section-footer-banner.component';

@NgModule({
  declarations: [SectionFooterBannerComponent],
  imports: [CommonModule, ButtonModule],
  exports: [SectionFooterBannerComponent],
})
export class SectionFooterBannerModule {}
